import { ManagerRole } from '../../../../hooks/auth/usePermissions';

export default {
  [ManagerRole.SuperAdmin]: 'Pääkäyttäjä',
  [ManagerRole.Admin]: 'Ylläpitäjä',
  [ManagerRole.SalesManager]: 'Myyntipäällikkö',
  [ManagerRole.SalesLeadership]: 'Myynnin johto',
  [ManagerRole.ContentManager]: 'Sisältöpäällikkö',
  [ManagerRole.OnboardingManager]: 'Käyttöönottopäällikkö',
  [ManagerRole.OccAgent]: 'Puhelinpalveluagentti',
};
